import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';
import { Factor, RiskScoreCalculationType, RiskScoreType } from '../../types';
import {
  useUpdateFactorMutation,
  useLazyGetFactorsQuery,
} from '../../../store/dictionaries/services';
import GeographicalRiskForm from '../../../components/geogrpahical/form';

const TransactionsRiskGeographical = () => {
  const { control, handleSubmit, watch, reset } = useForm();

  const [weightErrorVisible, setWeightErrorVisible] = useState(false);

  const transactionsCalculate = watch('transactionsCalculate');

  const { activePermissions, factors } = useAppSelector(
    (state) => state.amlDictionaries,
  );

  const [getFactors] = useLazyGetFactorsQuery();

  const currentFactors = {
    transactions: {
      nationality: factors?.find(
        (item) => item.type === RiskScoreType.COUNTRY_OF_THE_COUNTERPARTY,
      ),
      countryOfResidence: factors?.find(
        (item) =>
          item.type === RiskScoreType.COUNTRY_OF_THE_BANK_OF_COUNTERPARTY,
      ),
      country: factors?.find((item) => item.type === RiskScoreType.COUNTRY),
    },
  };

  const [updateFactors, { isLoading: requestInProgress }] =
    useUpdateFactorMutation();

  const onFormSubmit = handleSubmit((formValues) => {
    let submitAllowed = false;

    if (formValues.transactionsCalculate === RiskScoreCalculationType.WEIGHT) {
      if (
        Number(formValues.transactionNationality) +
          Number(formValues.transactionCountryOfResidence) ===
        1
      ) {
        setWeightErrorVisible(false);

        submitAllowed = true;
      } else {
        setWeightErrorVisible(true);
      }
    } else if (
      formValues.transactionsCalculate !== RiskScoreCalculationType.WEIGHT
    ) {
      setWeightErrorVisible(false);

      submitAllowed = true;
    }

    if (submitAllowed) {
      const transactionCountryBody = {
        ...currentFactors.transactions.country,
        calculationType: formValues.transactionsCalculate,
      };
      const transactionNationalityBody = {
        ...currentFactors.transactions.nationality,
        weight:
          transactionsCalculate !== RiskScoreCalculationType.WEIGHT
            ? 0
            : Number(formValues.transactionNationality),
      };
      const transactionResidenceBody = {
        ...currentFactors.transactions.countryOfResidence,
        weight:
          transactionsCalculate !== RiskScoreCalculationType.WEIGHT
            ? 0
            : Number(formValues.transactionCountryOfResidence),
      };

      Promise.all([
        updateFactors({
          id: currentFactors?.transactions?.country?.id as string,
          body: transactionCountryBody as Factor,
        }),
        updateFactors({
          id: currentFactors?.transactions?.nationality?.id as string,
          body: transactionNationalityBody as Factor,
        }),
        updateFactors({
          id: currentFactors?.transactions?.countryOfResidence?.id as string,
          body: transactionResidenceBody as Factor,
        }),
      ]);
    }
  });

  useEffect(() => {
    if (
      currentFactors.transactions.country &&
      currentFactors.transactions.countryOfResidence &&
      currentFactors.transactions.nationality &&
      !transactionsCalculate
    ) {
      const body = {
        transactionNationality: currentFactors.transactions.nationality.weight,
        transactionCountryOfResidence:
          currentFactors.transactions.countryOfResidence.weight,
        transactionsCalculate:
          currentFactors.transactions.country.calculationType,
      };

      reset(body);
    }
  }, [currentFactors, transactionsCalculate, reset]);

  useEffect(() => {
    if (!factors) {
      getFactors();
    }
  }, [factors]);

  return (
    <GeographicalRiskForm
      control={control}
      onSubmit={onFormSubmit}
      transactionsCalculate={transactionsCalculate}
      requestInProgress={requestInProgress}
      updateAllowed={activePermissions?.includes(
        PermissionEnum.SETTINGS_FACTORS_ACTION,
      )}
      weightErrorVisible={weightErrorVisible}
      transactionsRisk
    />
  );
};

export default TransactionsRiskGeographical;
